import axios from "axios";
import { API_YCLICK_MASTER, API_ADMINISTRATION, API_SERVICIOS } from "../constants/host";
import apiInterceptors from "./apiInterceptors";

// Maestro Global (used in Services/Materials)
const apiYClickMasterInstance = axios.create({
  baseURL: API_YCLICK_MASTER,
});

apiInterceptors(apiYClickMasterInstance, true);

// Only for Login (the Masters API is used)
// To avoid sending a token
const apiYClickLoginInstance = axios.create({
  baseURL: API_YCLICK_MASTER,
});

apiInterceptors(apiYClickLoginInstance, false);

// Administracion
const apiYClickAdministrationInstance = axios.create({
  baseURL: API_ADMINISTRATION,
});

apiInterceptors(apiYClickAdministrationInstance, true);

//Servicios

const apiYClickServiciosInstance = axios.create({
  baseURL: API_SERVICIOS,
});
apiInterceptors(apiYClickServiciosInstance, true);

export {
  apiYClickMasterInstance as apiYclickMaster,
  apiYClickLoginInstance as apiYClickLogin,
  apiYClickAdministrationInstance as apiYClickAdministration,
  apiYClickServiciosInstance as apiYClickServicios
};
